import React, {PropTypes} from 'react';
import Slider from 'material-ui/Slider';
import {FormattedTime} from 'react-intl';
import IconButton from 'material-ui/IconButton';
import {VideoModel} from '../../../api/video';
import {AwsVideo} from '../../../api/videoAws';
import HLSPlayer from '../../HLSPlayer';
import {LiveImage} from '../../../api/image';
import IconAdd from '../../Icons/IconAdd';
import IconDelete from '../../Icons/IconDelete';
import IconReload from '../../Icons/IconReload';
import IconPlay from '../../Icons/IconPlay';
import IconPause from '../../Icons/IconPause';
import IconMakeScreenShot from '../../Icons/IconMakeScreenShot';
import ErrorContainer from '../ErrorContainer';
import {drawImageFromVideo, autoCropImage} from '../../../utilites/ImageProcessor';

class VideoInput extends React.Component {
  static propTypes = {
    abbLabel: PropTypes.node.isRequired,
    label: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.instanceOf(VideoModel), PropTypes.instanceOf(AwsVideo)]),
    disabled: PropTypes.bool.isRequired,
    onScreenShotImage: PropTypes.func,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    screenShotImageSize: { width: PropTypes.number, height: PropTypes.number }
  };

  static defaultProps = {
    label: 'Video',
    abbLabel: (<span>Upload video</span>),
    disabled: false
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  state = {
    currentTime: 0,
    duration: 1,
    editItem: false,
    videoPlaying: false
  };

  getStyle() {
    let imageSize = 300;
    let {muiTheme} = this.context;
    let {disabled} = this.props;
    let {editItem} = this.state;

    const hoverColor = 'rgba(51, 51, 51, 0.8)';

    return {
      block: {
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        minHeight: 100,
        width: '100%'
      },
      grayBg: {
        backgroundColor: hoverColor
      },
      icon: {
        textAlign: 'center',
        cursor: disabled ? 'default' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: imageSize,
        height: imageSize,
        margin: '0 auto'
      },
      image: {
        display: 'block',
        margin: '0 auto',
        maxWidth: '100%'
      },
      editImageHover: {
        display: disabled || !editItem ? 'none' : 'flex',
        backgroundColor: hoverColor,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        alignItems: 'center',
        justifyContent: 'center'
      },
      button: {
        cursor: 'pointer',
        backgroundColor: 'rgb(0, 0, 0, 0.6)',
        color: muiTheme.appBar.textColor
      }
    };
  }

  constructor() {
    super();
    this._videoId = 'video_upload';
  }

  _getValue() {
    return this.props.value || new VideoModel();
  }

  async selectVideo(event) {
    let file = event.target.files[0];
    let {onChange, onBlur} = this.props;
    let newVideo = await this._getValue().setVideoFile(file);
    this.setState({
      currentTime: 0,
      duration: 1
    });
    onChange(newVideo);
    onBlur(newVideo);
  }

  toggleEdit = (editItem) => {
    this.setState({editItem});
  };

  clearValue() {
    this.props.onChange(null);
  }

  playVideo = () => {
    let {videoPlaying} = this.state;
    let {videoPlayer} = this.refs;

    if (videoPlaying) {
      videoPlayer.pause();
    } else {
      videoPlayer.play();
    }

    this.setState({videoPlaying: !videoPlaying});
  };

  moveVideo = (event, value) => {
    let {videoPlayer} = this.refs;
    videoPlayer.currentTime = value;
  };

  onVideoTimeUpdate = () => {
    let {videoPlayer} = this.refs;
    this.setState({currentTime: Math.ceil(videoPlayer.currentTime)});
  };

  onVideoLoad = () => {
    let {videoPlayer} = this.refs;
    this.setState({duration: Math.ceil(videoPlayer.duration)});
  };

  parseImage = () => {
    return async () => {
      if (this.props.onScreenShotImage && this.props.screenShotImageSize) {
        let imageBlob = await drawImageFromVideo(this.refs.videoPlayer, this.refs.videoPlayer.videoWidth,  this.refs.videoPlayer.videoHeight);
        let image = await autoCropImage(new LiveImage(imageBlob).file, this.props.screenShotImageSize.width, this.props.screenShotImageSize.height);
        this.props.onScreenShotImage(new LiveImage(image));
      }
    }
  };

  reload = () => {
    this.refs.fileInput.click();
  };

  render() {

    let {value, label, allowedFormats} = this.props;
    let size = this.props.size ? this.props.size : '1GB';
    let styles = {'fontSize': '14px', 'fontWeight': 'normal'};
    let maxVideoSize = (<small style={styles}>{'Allowed video size: ' + size}</small>);
    let allowedVideoFormats = allowedFormats ? (
      <small style={styles}>{'Allowed video formats: ' + allowedFormats}</small>) : '';
    let newLabel = (
      <span>
        {label}
        <br/>
        {maxVideoSize}
        <br/>
        {allowedVideoFormats}
      </span>
    );
    return (
      <ErrorContainer id={this._videoId} {...this.props} label={newLabel}>
        {
          !value
            ? this._renderEmptyVideo()
            : (
            value instanceof AwsVideo
              ? <HLSPlayer value={value}/>
              : this._renderChosedNewVideo()
          )
        }

        <input type='file'
               accept='video/mp4'
               id={this._videoId}
               ref='fileInput'
               style={{display: 'none'}}
               onClick={(e) => e.target.value = null}
               onChange={(e) => this.selectVideo(e)}
        />
      </ErrorContainer>
    );
  }


  _renderEmptyVideo() {
    let style = this.getStyle();
    let {abbLabel} = this.props;

    return (
      <div style={Object.assign({}, style.block, style.grayBg)}>
        <label htmlFor={this._videoId}>
          <div style={style.icon}>
            <div>
              <IconAdd color='white'/>
              <div style={{color: 'white'}}>{abbLabel}</div>
            </div>
          </div>
        </label>
      </div>
    );
  }

  _renderChosedNewVideo() {
    let style = this.getStyle();
    let {value = {}, disabled} = this.props;
    let {videoPlaying, currentTime, duration} = this.state;

    return (
      <div>
        <div onMouseEnter={() => this.toggleEdit(true)} onMouseLeave={() => this.toggleEdit(false)}
             style={style.block}>
          <video src={value.url} width='100%' ref='videoPlayer'
                 onTimeUpdate={this.onVideoTimeUpdate}
                 onLoadedMetadata={this.onVideoLoad}>
          </video>
          <div style={style.editImageHover}>
            <IconButton onClick={this.playVideo}>
              {videoPlaying
                ? (<IconPause color='white'/>)
                : (<IconPlay color='white'/>)
              }
            </IconButton>

            {!videoPlaying ? (
              <IconButton disabled={disabled} onClick={this.parseImage()}>
                <IconMakeScreenShot color='white'/>
              </IconButton>
            ) : null}

            {!videoPlaying ? (
              <IconButton disabled={disabled} onClick={() => !disabled && this.reload()}>
                <IconReload color='white'/>
              </IconButton>
            ) : null}

            {!videoPlaying ? (
              < IconButton disabled={disabled} onClick={() => !disabled && this.clearValue()}>
                <IconDelete color='white'/>
              </IconButton>
            ) : null}
          </div>
        </div>
        <Slider
          style={{
            margin: '-13px 0 0 0'
          }}
          sliderStyle={{
            margin: 0
          }}
          value={currentTime}
          min={0}
          max={duration}
          step={1}
          onChange={this.moveVideo}
        />
        <div style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <FormattedTime format='MM:SS' value={new Date(currentTime * 1000)}/>
          <FormattedTime format='MM:SS' value={new Date(duration * 1000)}/>
        </div>
      </div>
    );
  }
}

export default VideoInput;





// WEBPACK FOOTER //
// ./src/components/form/VideoInput/VideoInput.js